import { render, staticRenderFns } from "./ViewProduct.vue?vue&type=template&id=1bbeb1b8&"
import script from "./ViewProduct.vue?vue&type=script&lang=js&"
export * from "./ViewProduct.vue?vue&type=script&lang=js&"
import style0 from "./ViewProduct.vue?vue&type=style&index=0&id=1bbeb1b8&prod&lang=scss&"
import style1 from "./ViewProduct.vue?vue&type=style&index=1&id=1bbeb1b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports